import { Checkbox, TableBody, TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';

const PBTableCells = ({
  styles,
  isMobile,
  rows,
  hideShading,
  favioute,
  toggleModal,
  setState,
  checkPut,
  setCheckedValue,
}) => {
  const { quoteInfo, targetPrice } = useSelector((state) => state.appReducer);
  const { latestPrice } = quoteInfo;

  return (
    <TableBody>
      {rows.map((row, index) => {
        const itm = row.itm;
        const noTargetPrice = !targetPrice || targetPrice * 1 === 0;

        const shadeRow =
          (targetPrice < latestPrice && (itm >= 0.4549 || itm <= 0.245)) ||
          (targetPrice > latestPrice && !noTargetPrice) ||
          (noTargetPrice && (itm >= 0.4549 || itm <= 0.245));

        return (
          <TableRow
            key={index}
            style={
              !hideShading && shadeRow ? styles.shadedRow : styles.tableRow
            }
          >
            <TableCell
              style={
                !hideShading && shadeRow
                  ? styles.shadedTableCell
                  : styles.tableCell
              }
            >
              {row.theo_bid.toFixed(2)}
            </TableCell>
            <TableCell
              style={
                !hideShading && shadeRow
                  ? styles.shadedTableCell
                  : styles.tableCell
              }
            >
              {row.theo_ask && row.theo_ask.toFixed(2)}
            </TableCell>
            <TableCell
              style={
                !hideShading && shadeRow
                  ? isMobile
                    ? styles.shadedTableCellClickableMobile
                    : styles.shadedTableCellClickable
                  : isMobile
                  ? styles.tableCellClickableMobile
                  : styles.tableCellClickable
              }
              className="toggleCell"
              onClick={() => toggleModal(row)}
            >
              {row.volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </TableCell>

            {!isMobile && (
              <TableCell
                className="toggleCellsOI"
                style={
                  !hideShading && shadeRow
                    ? styles.shadedTableCellClickableOI
                    : styles.tableCellClicKableOI
                }
                onClick={async () => {
                  setState({
                    isOIchecked: true,
                    modalRowData: row,
                  });
                  setState({ shouldOpenModal: true });
                }}
              >
                {row.open_int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </TableCell>
            )}
            {!isMobile && (
              <TableCell
                style={
                  !hideShading && shadeRow ? styles.shadedRRCell : styles.RRCell
                }
              >
                {!row.RR ? 'NA' : row.RR.toFixed(2)}
              </TableCell>
            )}
            {favioute && checkPut.length > 0 && (
              <TableCell style={styles.shadedTableCell}>
                <Checkbox
                  checked={checkPut[index] && checkPut[index].value}
                  style={{ height: '5px', color: 'darkgray' }}
                  onClick={() => setCheckedValue(index, row)}
                />
              </TableCell>
            )}
          </TableRow>
        );
      })}
    </TableBody>
  );
};
export default PBTableCells;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicPutBoard/basiCPutBoardWeb/putBoardTableCells.jsx